// extracted by mini-css-extract-plugin
export var container = "_rb-0";
export var table = "_rb-2";
export var tableWrapper = "_rb-1";